
import React, { useState } from "react";
import axios from "axios";
import BlueButton from "./BlueButton";
import { BRAND } from "../css/brand";

export default function ApplyPolicyModal({ device, onClose }) {
  const [policy, setPolicy] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!device) return null; // safety check

  const handleApply = async () => {
    if (!policy || !device.ama_device_id) {
      alert("Missing required fields");
      return;
    }

    const payload = {
      customerId:device.id,
      retailerId: device.retailer_id,
      policy: policy,
      serial:device.serial,
      deviceName:device.ama_device_id,
      imei:device.imei1
    };

    try {
      setLoading(true);
      setError(null);

      const res = await axios.post(
        "https://spillas.com/api/v1/policy-patch-php-new",
        payload
      );

      console.log("✅ Policy applied successfully:", res.data);
      alert("Policy applied successfully!");
      onClose();
    } catch (err) {
      console.error("❌ Error applying policy:", err);
      setError("Failed to apply policy. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
   <div className="fixed inset-0 bg-black bg-opacity-40 flex items-start justify-center z-50 pt-40">
  <div className="bg-white rounded-xl shadow-xl p-6 w-[400px] relative">
    <h2 className="text-lg font-semibold text-center mb-2">
      Device ID: {device.device_id}
    </h2>
    <p className="text-center text-gray-500 mb-4">
      Enterprise ID: {device.enterprise_id}
    </p>

    <label className="block text-sm font-medium mb-2 text-center">
      Select Policy to Apply:
    </label>
    <select
      value={policy}
      onChange={(e) => setPolicy(e.target.value)}
      className="w-full border rounded-lg p-2 mb-4"
    >
      <option >Select policy</option>
      <option value={"goexzerotouch"}>Default</option>
      <option value={"LockDevice"}>Lock Device</option>
      <option value={"hardlock"}>Hard lock</option>
      <option value={"UnlockDevice"}>Unlock</option>
      <option value={"UnistallDevice"}>TMP Remove</option>
      <option value={"UnistallDevice"}>Factory Reset On</option>
      <option value={"goexzerotouch"}>Factory Reset Off</option>
      <option value={"DisableApp"}>App Block</option>
      <option value={"goexzerotouch"}>App Unblock</option>
      <option value={"unlockusb"}>File Transfer On</option>
      <option value={"goexzerotouch"}>File Transfer Off</option>
      <option value={"developer_option_on"}>Developer mode On</option>
      <option value={"goexzerotouch"}>Developer mode Off</option>
      <option value={"goexzerotouch"}>Outgoing Call On</option>
      <option value={"outGoingOff"}>Outgoing Call Off</option>
      <option value={"goexzerotouch"}>Camera On</option>
      <option value={"cameraOff"}>Camera Off</option>
    </select>

    {error && (
      <p className="text-red-500 text-sm text-center mb-2">{error}</p>
    )}

    <div className="flex justify-end gap-2">
      <button
        onClick={onClose}
        className="px-3 py-1 border rounded-lg hover:bg-gray-100"
        disabled={loading}
      >
        Cancel
      </button>
      <BlueButton brand={BRAND} onClick={handleApply} disabled={loading}>
        {loading ? "Applying..." : "Apply Policy"}
      </BlueButton>
    </div>
  </div>
</div>

  );
}




// import React, { useState } from "react";
// import BlueButton from "./BlueButton";
// import { BRAND } from "../css/brand";

// export default function ApplyPolicyModal({ device, onClose }) {
//   const [policy, setPolicy] = useState("Default");

//   if (!device) return null; // safety check

//   const handleApply = async () => {
//     console.log("Applying policy:", policy, "to", device);
//     // API call can go here
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//       <div className="bg-white rounded-xl shadow-xl p-6 w-[400px] relative">
//         <h2 className="text-lg font-semibold text-center mb-2">
//           Device ID: {device.device_id}
//         </h2>
//         <p className="text-center text-gray-500 mb-4">
//           Enterprise ID: {device.enterprise_id}
//         </p>

//         <label className="block text-sm font-medium mb-2 text-center">
//           Select Policy to Apply:
//         </label>
//         <select
//           value={policy}
//           onChange={(e) => setPolicy(e.target.value)}
//           className="w-full border rounded-lg p-2 mb-4"
//         >
//           <option>Default</option>
//           <option>Unlock Device</option>
//           <option>Lock Device</option>
//           <option>Uninstall Device</option>
//           <option>Disable App</option>
//           <option>Unlock USB</option>
//           <option>Developer Option On</option>
//           <option>Dev USB Both Enable</option>
//         </select>

//         <div className="flex justify-end gap-2">
//           <button
//             onClick={onClose}
//             className="px-3 py-1 border rounded-lg hover:bg-gray-100"
//           >
//             Cancel
//           </button>
//           <BlueButton brand={BRAND} onClick={handleApply}>
//             Apply Policy
//           </BlueButton>
//         </div>
//       </div>
//     </div>
//   );
// }
